import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// animation
import AOS from 'aos';
import 'aos/dist/aos.css';
// icon
import { FaAngleDown } from 'react-icons/fa6';
// data
import { data } from '../../data/Faq';
// style
import style from './faq.module.css';

const Faq = () => {
  const [clicked, setClicked] = useState(null);

  const toggleSubMenu = {
    enter: {
      height: 'auto',
      overflow: 'hidden',
    },
    exit: {
      height: 0,
      overflow: 'hidden',
    },
  };

  // animation effect
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className={style.section}>
      <div className="container">
        <div className={style.contnet}>
          <div className="title">
            <h2>
              Часто задаваемые <span>вопросы</span>
            </h2>
          </div>
          <ul className={style.faq}>
            {data.map((item, i) => {
              const isClicked = clicked === i;

              return (
                <li
                  key={item.id}
                  onClick={() => setClicked(isClicked ? null : i)}
                  className={style.box}
                  data-aos="fade-up"
                >
                  <span className={style.que}>
                    <FaAngleDown className={isClicked && style.icon} />
                    {item.question}
                  </span>
                  <motion.ul
                    initial="exit"
                    animate={isClicked ? 'enter' : 'exit'}
                    variants={toggleSubMenu}
                  >
                    <li className={style.answ}>{item.answer}</li>
                  </motion.ul>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Faq;
